const collectCampaignInfoProperties = ({ campaignData }) => {
  const { id, originCampaignId, title } = campaignData.campaign;
  return {
    customize_campaign_id: originCampaignId,
    refills_campaign_id: id,
    refills_campaign_name: title,
  };
};

export default collectCampaignInfoProperties;
